import type { FC } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "@privacy/translations";
import { AssistantMessageText } from "./AssistantMessageText";

const LARGE = { fontSize: "1.375rem", lineHeight: 1.4 } as const;
const NORMAL = { fontSize: "0.875rem", lineHeight: 1.5 } as const;

type AssistantWelcomeProps = { isLarge: boolean; shrinksIn?: boolean };

export const AssistantWelcome: FC<AssistantWelcomeProps> = ({ isLarge, shrinksIn = false }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        "maxWidth": isLarge ? 680 : 520,
        "&& .MuiTypography-body1": {
          ...(isLarge ? LARGE : NORMAL),
          animation: shrinksIn && !isLarge ? "assistantWelcomeShrink 400ms ease-out" : "none",
        },
        "@keyframes assistantWelcomeShrink": { from: LARGE, to: NORMAL },
        "@media (prefers-reduced-motion: reduce)": { "&& .MuiTypography-body1": { animation: "none" } },
      }}
    >
      <AssistantMessageText text={t("Assistant.FirstMessage")} />
    </Box>
  );
};
